export default __webpack_public_path__ + "static/media/interior-1.c2a07f5d.jpg";